var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReatil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_4576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 19.4062H4.3125C2.33091 19.4062 0.71875 17.7941 0.71875 15.8125V4.3125C0.71875 2.33091 2.33091 0.71875 4.3125 0.71875H18.6875C20.6691 0.71875 22.2812 2.33091 22.2812 4.3125V15.8125C22.2812 17.7941 20.6691 19.4062 18.6875 19.4062ZM4.3125 2.15625C3.12369 2.15625 2.15625 3.12369 2.15625 4.3125V15.8125C2.15625 17.0013 3.12369 17.9688 4.3125 17.9688H18.6875C19.8763 17.9688 20.8438 17.0013 20.8438 15.8125V4.3125C20.8438 3.12369 19.8763 2.15625 18.6875 2.15625H4.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2573 22.2812H6.74316L8.90013 17.9688H14.0989L16.2573 22.2812ZM9.06904 20.8438H13.9299L13.2105 19.4062H9.78851L9.06904 20.8438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 20.8433H5.03125C4.6343 20.8433 4.3125 21.1651 4.3125 21.562C4.3125 21.959 4.6343 22.2808 5.03125 22.2808H17.9688C18.3657 22.2808 18.6875 21.959 18.6875 21.562C18.6875 21.1651 18.3657 20.8433 17.9688 20.8433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54395 11.8398C9.9409 11.8398 10.2627 11.518 10.2627 11.1211C10.2627 10.7241 9.9409 10.4023 9.54395 10.4023C9.14699 10.4023 8.8252 10.7241 8.8252 11.1211C8.8252 11.518 9.14699 11.8398 9.54395 11.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4697 11.8398C13.8667 11.8398 14.1885 11.518 14.1885 11.1211C14.1885 10.7241 13.8667 10.4023 13.4697 10.4023C13.0728 10.4023 12.751 10.7241 12.751 11.1211C12.751 11.518 13.0728 11.8398 13.4697 11.8398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5214 15.5248H8.4774C7.44312 15.5248 6.5224 14.8305 6.2385 13.8358L5.46297 11.1239C5.261 10.4153 5.399 9.67063 5.84318 9.08197C6.28665 8.49332 6.96515 8.15479 7.70259 8.15479H15.2969C16.0343 8.15479 16.7121 8.4926 17.1563 9.08125C17.5998 9.66991 17.7385 10.4145 17.5358 11.1239L16.7603 13.8358C16.4757 14.8298 15.5557 15.5248 14.5214 15.5248ZM7.70259 9.59229C7.42012 9.59229 7.16065 9.72166 6.99103 9.94735C6.8214 10.173 6.7675 10.4577 6.84584 10.7286L7.62137 13.4405C7.72918 13.8207 8.08209 14.0866 8.4774 14.0866H14.5214C14.9174 14.0866 15.2696 13.8207 15.3774 13.4412L16.1529 10.7286C16.2306 10.4569 16.1781 10.1723 16.0077 9.94663C15.8381 9.72166 15.5787 9.59229 15.2969 9.59229H7.70259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3374 9.5925H8.66211V6.75559C8.66211 5.19087 9.93502 3.91797 11.4997 3.91797C13.0645 3.91797 14.3366 5.19087 14.3366 6.75559L14.3374 9.5925ZM10.0996 8.155H12.8999V6.75559C12.8999 5.98366 12.2717 5.35547 11.5005 5.35547C10.7292 5.35547 10.1003 5.98366 10.1003 6.75559V8.155H10.0996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_4576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReatil);
export default __webpack_public_path__ + "static/media/Reatil.a83022d2063d9645917702f603b50e09.svg";
export { ForwardRef as ReactComponent };